import React from "react";
import { Dialog, DialogContent } from "@ui/dialog";

const FullCertificate = ({
  open,
  setOpen,
  imageUrl,
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  imageUrl: string | undefined;
}) => {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="flex items-center justify-center bg-white sm:max-w-[500px] dark:bg-dark_background">
        <img
          src={imageUrl}
          alt="no certificate"
          width={400}
          className="ms-3 mt-3"
        />
      </DialogContent>
    </Dialog>
  );
};

export default FullCertificate;
